import {ENDPOINT_FUNDING_OPPORTUNITY} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';
import _ from 'lodash';

const callGetFundingOpportunity = ({token, fundingOpportunityId}) => {
  return getFundingOpportunity(token, fundingOpportunityId);
};

const getFundingOpportunity = (token, fundingOpportunityId) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}${fundingOpportunityId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getFundingOpportunitiesForProgram = (token, programId) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}program/${programId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getFundingOpportunitiesAppExtensionsForFOAndGrant = (
  token,
  fundingOpportunityId,
  grantId
) => {
  return fetch(
    `${ENDPOINT_FUNDING_OPPORTUNITY}${fundingOpportunityId}/grant/${grantId}/appExtension`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getFundingOpportunitiesAppExtensionsForGrant = (token, grantId) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}grant/${grantId}/appExtension`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getFundingOpportunitiesAppExtensionsForFO = (token, fundingOpportunityId) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}${fundingOpportunityId}/appExtension`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const createFundingOpportunityDraft = (token, payload) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}createDraft`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(payload),
  });
};

const getDraftFundingOpportunitiesForProgramByStatus = (token, programId, status) => {
  return fetch(
    `${ENDPOINT_FUNDING_OPPORTUNITY}draftFoByProgramIdAndStatus/${programId}/${status}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const publishFundingOpportunityForProgram = (token, programId, draftId) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}publish/${programId}/${draftId}`, {
    method: 'PUT',
    headers: commonJwtHeader(),
  });
};

const addFundingOpportunityCommitment = (fundingOpportunityId, payload) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}${fundingOpportunityId}/commitment`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(payload),
  });
};

const callUpdateFundingOpportunityConfig = ({
  token,
  fundingOpportunityId,
  payload,
  congressionalNotificationWaiver,
  attachments,
}) => {
  let tempPayload = _.cloneDeep(payload);
  _.setWith(
    tempPayload,
    'foOverview.congressionalNotificationWaiver',
    congressionalNotificationWaiver
  );
  _.setWith(
    tempPayload,
    'congressionalNotificationWaiverAttachmentIds',
    congressionalNotificationWaiver == 'Yes' ? attachments : []
  );
  return updateFundingOpportunityConfig(token, fundingOpportunityId, tempPayload);
};

const updateFundingOpportunityConfig = (token, fundingOpportunityId, payload) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}${fundingOpportunityId}/config`, {
    method: 'PUT',
    headers: commonJwtHeader(token),
    body: JSON.stringify({configData: JSON.stringify(payload)}),
  });
};

export default {
  callGetFundingOpportunity,
  getFundingOpportunity,
  getFundingOpportunitiesForProgram,
  getFundingOpportunitiesAppExtensionsForFOAndGrant,
  getFundingOpportunitiesAppExtensionsForGrant,
  getFundingOpportunitiesAppExtensionsForFO,
  createFundingOpportunityDraft,
  getDraftFundingOpportunitiesForProgramByStatus,
  publishFundingOpportunityForProgram,
  addFundingOpportunityCommitment,
  callUpdateFundingOpportunityConfig,
  updateFundingOpportunityConfig,
};
